import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04229cf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "canvas-tool" }
const _hoisted_2 = {
  class: "left-handler",
  style: {"cursor":"pointer"}
}
const _hoisted_3 = {
  key: 1,
  class: "avatar"
}
const _hoisted_4 = { class: "workspase-text" }
const _hoisted_5 = {
  class: "right-handler",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_6 = {
  class: "top-btn",
  style: {"background-color":"#5230f2","color":"#fff"}
}
const _hoisted_7 = {
  style: {"width":"16px","height":"16px"},
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "26",
  viewBox: "0 0 41 33",
  fill: "none"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M30.4491 12.2792C30.4491 9.67074 29.4129 7.16913 27.5684 5.32468C25.724 3.48023 23.2224 2.44403 20.6139 2.44403C18.0055 2.44403 15.5039 3.48023 13.6594 5.32468C11.815 7.16913 10.7788 9.67074 10.7788 12.2792C9.81011 12.2792 8.85092 12.47 7.95597 12.8407C7.06103 13.2114 6.24787 13.7547 5.56291 14.4397C4.87795 15.1246 4.33461 15.9378 3.96392 16.8327C3.59322 17.7277 3.40242 18.6869 3.40242 19.6555C3.40242 20.6242 3.59322 21.5834 3.96392 22.4784C4.33461 23.3733 4.87795 24.1865 5.56291 24.8714C6.24787 25.5564 7.06103 26.0997 7.95597 26.4704C8.85092 26.8411 9.81011 27.0319 10.7788 27.0319V29.4907C8.36526 29.4939 6.03483 28.6095 4.23108 27.0059C2.42733 25.4023 1.2762 23.1914 0.996808 20.7941C0.717417 18.3968 1.32927 15.9804 2.7159 14.005C4.10254 12.0296 6.16713 10.633 8.5167 10.081C9.03553 7.25104 10.5301 4.69252 12.7404 2.85061C14.9507 1.00871 17.7368 0 20.6139 0C23.4911 0 26.2772 1.00871 28.4875 2.85061C30.6978 4.69252 32.1923 7.25104 32.7112 10.081C35.0525 10.6416 37.1071 12.041 38.4861 14.0145C39.8651 15.9879 40.4727 18.3984 40.194 20.7898C39.9153 23.1811 38.7696 25.3873 36.9738 26.9907C35.178 28.5942 32.8566 29.4836 30.4491 29.4907V27.0319C32.4054 27.0319 34.2816 26.2548 35.665 24.8714C37.0483 23.4881 37.8254 21.6119 37.8254 19.6555C37.8254 17.6992 37.0483 15.823 35.665 14.4397C34.2816 13.0563 32.4054 12.2792 30.4491 12.2792ZM10.7788 27.0319H13.2376V29.4907H10.7788V27.0319ZM27.9903 27.0319H30.4491V29.4907H27.9903V27.0319Z",
  fill: "#ffffff"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M21.6394 28.7701V15.9746C21.6369 15.6486 21.5068 15.3366 21.277 15.1054C21.0472 14.8743 20.736 14.7423 20.41 14.7378C19.7314 14.7378 19.1806 15.3107 19.1806 15.9746V28.7701L17.7939 27.3833C17.5618 27.1579 17.2505 27.0323 16.9269 27.0337C16.6033 27.0351 16.2931 27.1633 16.0629 27.3907C15.9476 27.5032 15.8559 27.6376 15.7931 27.7859C15.7302 27.9342 15.6975 28.0936 15.6968 28.2547C15.6961 28.4158 15.7275 28.5754 15.7891 28.7242C15.8506 28.8731 15.9412 29.0082 16.0555 29.1217L19.547 32.6156C19.6608 32.7285 19.796 32.8175 19.9446 32.8774C20.0932 32.9374 20.2523 32.9671 20.4125 32.9648C20.5723 32.9693 20.7313 32.9406 20.8794 32.8805C21.0275 32.8204 21.1616 32.7302 21.2731 32.6156L24.7646 29.1242C24.9908 28.8919 25.1168 28.5801 25.1154 28.2559C25.114 27.9317 24.9854 27.621 24.7572 27.3907C24.6446 27.2754 24.5103 27.1837 24.362 27.1209C24.2137 27.058 24.0543 27.0253 23.8932 27.0246C23.7321 27.0239 23.5725 27.0553 23.4237 27.1169C23.2748 27.1784 23.1397 27.269 23.0262 27.3833L21.6394 28.7701Z",
  fill: "#ffffff"
}, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  class: "top-btn",
  style: {"background-color":"#5230f2","color":"#fff"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1735302119550",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "12375",
  width: "200",
  height: "200"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M608 320C625.664 320 640 305.696 640 288L640 160C640 142.304 625.664 128 608 128 590.336 128 576 142.304 576 160L576 288C576 305.696 590.336 320 608 320L608 320ZM960 896C960 931.328 931.328 960 896 960L128 960C92.672 960 64 931.328 64 896L64 128C64 92.672 92.672 64 128 64L192 64 192 384C192 419.328 220.672 448 256 448L768 448C803.328 448 832 419.328 832 384L832 64 896 64C931.328 64 960 92.672 960 128L960 896 960 896ZM256 64 768 64 768 352C768 369.696 753.664 384 736 384L288 384C270.336 384 256 369.696 256 352L256 64 256 64ZM896 0 128 0C57.312 0 0 57.312 0 128L0 896C0 966.688 57.312 1024 128 1024L896 1024C966.688 1024 1024 966.688 1024 896L1024 128C1024 57.312 966.688 0 896 0L896 0Z",
    fill: "#ffffff",
    "p-id": "12376"
  })
], -1))
const _hoisted_13 = { class: "top-btn" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1715233720081",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "5936",
  width: "18",
  height: "18"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M810.992 657.773c-56.756 0-105.51 32.073-130.712 78.735L349.52 568.816c8.258-18.53 13.06-38.927 13.06-60.521 0-22.947-5.606-44.426-14.866-63.847l345.377-142.333c27.287 35.087 69.429 58.06 117.318 58.06 82.363 0 149.133-66.769 149.133-149.133 0-82.363-66.77-149.133-149.133-149.133-82.365 0-149.132 66.77-149.132 149.133 0 7.739 1.14 15.173 2.278 22.594L296.937 384.721c-23.826-16.127-52.552-25.559-83.489-25.559-82.365 0-149.132 66.77-149.132 149.133 0 82.365 66.767 149.132 149.132 149.132 33.072 0 63.337-11.116 88.068-29.335L662.271 810.99c2.215 80.427 67.756 145.048 148.722 145.048 82.363 0 149.132-66.768 149.132-149.132 0-82.362-66.77-149.133-149.133-149.133z",
    fill: "currentColor",
    "p-id": "5937"
  })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "share-link-box" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1715326494015",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "5036",
    width: "20",
    height: "20"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M948.245 0H75.52C33.877 0 0.021 33.067 0.021 73.813v876.288C0 990.891 33.877 1024 75.52 1024h872.704c41.75 0 75.733-33.11 75.733-73.899V73.835C1024 33.045 989.995 0 948.267 0z",
      fill: "#007BB5",
      "p-id": "5037"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M151.744 383.893h152.021v488.64H151.744v-488.64z m76.053-242.922a88.107 88.107 0 1 1-0.128 176.17 88.107 88.107 0 0 1 0.128-176.17M399.04 383.893h145.579v66.795h2.09c20.267-38.4 69.803-78.933 143.702-78.933 153.77 0 182.186 101.184 182.186 232.81v267.968h-151.85V634.88c0-56.661-0.982-129.557-78.934-129.557-79.018 0-91.093 61.76-91.093 125.525v241.707H399.04V383.872z",
      fill: "#FFFFFF",
      "p-id": "5038"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "share-link-text" }, "LinkedIn")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "share-link-box" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1715327248006",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "29208",
    width: "20",
    height: "20"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M967.601349 1024c31.076808 0 56.398651-25.321843 56.398651-56.398651V56.398651c0-31.076808-25.321843-56.398651-56.398651-56.398651H56.398651C25.321843 0 0 25.321843 0 56.398651v910.819034c0 31.076808 25.321843 56.398651 56.398651 56.398651h911.202698z",
      fill: "#3C5A99",
      "p-id": "29209"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M706.709629 1024V627.29112h133.13151l19.950543-154.61671h-153.082053V374.072686c0-44.888722 12.277257-75.198202 76.732859-75.198201h81.720494v-138.119146c-14.195579-1.918321-62.920944-6.138629-119.319595-6.138629-118.168602 0-198.738104 72.128887-198.738104 204.109405v113.948295h-133.515174v154.61671h133.515174v396.70888h159.604346z",
      fill: "#FFFFFF",
      "p-id": "29210"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "share-link-text" }, "Facebook")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "share-link-box" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1715326873025",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "7054",
    width: "20",
    height: "20"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M238.08 64h547.84A174.08 174.08 0 0 1 960 238.08v547.84A174.08 174.08 0 0 1 785.92 960H238.08A174.08 174.08 0 0 1 64 785.92V238.08A174.08 174.08 0 0 1 238.08 64z",
      fill: "#170B1A",
      "p-id": "7055"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M512 328.32V159.36h115.2a112 112 0 0 0 0 29.44H544.64v456.96a110.08 110.08 0 0 1-13.44 58.24 94.72 94.72 0 0 1-128 35.2 94.72 94.72 0 0 1-32.64-28.8 95.36 95.36 0 0 0 96-6.4A96.64 96.64 0 0 0 512 622.72v-294.4z m192-32.64a163.2 163.2 0 0 0 51.84 22.4 143.36 143.36 0 0 0 33.28 0v26.24A165.76 165.76 0 0 1 704 295.68z",
      fill: "#25F4EE",
      "p-id": "7056"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M304.64 439.04a208 208 0 0 1 138.88-28.8v26.88a256 256 0 0 0-37.76 4.48A221.44 221.44 0 0 0 320 480a204.8 204.8 0 0 0-64 79.36 216.32 216.32 0 0 0 6.4 196.48 146.56 146.56 0 0 0 28.8 39.68 200.32 200.32 0 0 1-59.52-64 213.76 213.76 0 0 1-29.44-115.2 217.6 217.6 0 0 1 102.4-177.28z",
      fill: "#25F4EE",
      "p-id": "7057"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M544.64 192h85.12a169.6 169.6 0 0 0 16.64 46.72 145.28 145.28 0 0 0 50.56 56.96h3.84a163.84 163.84 0 0 0 85.76 51.84v89.6a269.44 269.44 0 0 1-158.08-49.92v243.84a233.6 233.6 0 0 1-30.72 99.2 218.88 218.88 0 0 1-60.16 67.84 192 192 0 0 1-108.8 37.76 267.52 267.52 0 0 1-58.88-3.84 224.64 224.64 0 0 1-76.16-33.28 161.28 161.28 0 0 1-28.8-39.68 208.64 208.64 0 0 1-26.88-101.76A218.88 218.88 0 0 1 320 480a221.44 221.44 0 0 1 85.76-38.4 243.84 243.84 0 0 1 37.76-4.48v92.16a78.08 78.08 0 0 0-45.44 0 115.2 115.2 0 0 0-48.64 23.68 88.32 88.32 0 0 0-19.84 23.04 101.12 101.12 0 0 0-9.6 58.24 97.28 97.28 0 0 0 21.76 49.92 128 128 0 0 0 28.8 24.32 100.48 100.48 0 0 0 32.64 28.8 97.28 97.28 0 0 0 55.04 11.52 94.08 94.08 0 0 0 72.32-44.8 114.56 114.56 0 0 0 14.08-55.68c0.64-154.88 0-307.2 0-456.32z",
      fill: "#FFFFFF",
      "p-id": "7058"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M629.76 192h30.72a165.12 165.12 0 0 0 29.44 94.08l7.68 9.6a140.16 140.16 0 0 1-50.56-56.96A184.96 184.96 0 0 1 629.76 192z m156.8 158.72a195.2 195.2 0 0 0 33.28 3.2v112.64a270.72 270.72 0 0 1-159.36-51.84v230.4a203.52 203.52 0 0 1-5.12 51.84 213.12 213.12 0 0 1-84.48 128 200.96 200.96 0 0 1-75.52 33.92 208.64 208.64 0 0 1-200.96-64 219.52 219.52 0 0 0 76.16 37.12 264.32 264.32 0 0 0 59.52 5.12 192 192 0 0 0 108.8-37.76 216.96 216.96 0 0 0 59.52-67.84 234.24 234.24 0 0 0 31.36-99.2v-30.08-215.04a268.16 268.16 0 0 0 158.08 49.92c-1.28-29.44-0.64-60.16-1.28-89.6z",
      fill: "#FE2C55",
      "p-id": "7059"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M444.16 437.12a192 192 0 0 1 33.28 0v120.96a88.96 88.96 0 0 0-49.92 0 99.2 99.2 0 0 0-69.12 64 96.64 96.64 0 0 0 12.8 90.24 105.6 105.6 0 0 1-28.8-24.32A92.16 92.16 0 0 1 320 632.32 94.08 94.08 0 0 1 330.24 576a103.04 103.04 0 0 1 21.12-26.24 119.04 119.04 0 0 1 48.64-23.68 78.72 78.72 0 0 1 45.44 0v-56.32c-1.28-10.24 2.56-21.76-1.28-32.64z",
      fill: "#FE2C55",
      "p-id": "7060"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "share-link-text" }, "Tiktok")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "share-link-box" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1715326920199",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "8069",
    width: "20",
    height: "20"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M136.533333 0h750.933334c75.093333 0 136.533333 61.44 136.533333 136.533333v750.933334c0 75.093333-61.44 136.533333-136.533333 136.533333H136.533333c-75.093333 0-136.533333-61.44-136.533333-136.533333V136.533333c0-75.093333 61.44-136.533333 136.533333-136.533333z",
      fill: "#1296db",
      "p-id": "8070"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M747.52 402.773333v-17.066666c23.893333-17.066667 44.373333-40.96 61.44-64.853334-20.48 10.24-44.373333 17.066667-68.266667 20.48 23.893333-13.653333 44.373333-40.96 54.613334-68.266666-23.893333 13.653333-47.786667 23.893333-75.093334 30.72-20.48-23.893333-54.613333-40.96-88.746666-40.96-68.266667 0-119.466667 54.613333-119.466667 126.293333 0 10.24 0 20.48 3.413333 30.72-98.986667-6.826667-187.733333-58.026667-249.173333-136.533333-17.066667 13.653333-23.893333 34.133333-23.893333 58.026666 0 44.373333 20.48 85.333333 54.613333 109.226667-20.48 0-37.546667-6.826667-54.613333-17.066667 0 61.44 40.96 116.053333 95.573333 126.293334-10.24 3.413333-20.48 3.413333-30.72 3.413333-6.826667 0-13.653333 0-23.893333-3.413333 13.653333 51.2 61.44 88.746667 112.64 88.746666-40.96 34.133333-92.16 54.613333-150.186667 54.613334-10.24 0-20.48 0-27.306667-3.413334 54.613333 37.546667 116.053333 58.026667 184.32 58.026667 221.866667 6.826667 344.746667-187.733333 344.746667-354.986667z",
      fill: "#ffffff",
      "p-id": "8071"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "share-link-text" }, "Twitter")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "share-link-box" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1715326983661",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "13723",
    width: "20",
    height: "20"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M229.518 1024h122.206L158.896 900.414 0.396 807.796C7.318 928.18 107.432 1024 229.518 1024z",
      fill: "#FDE494",
      "p-id": "13724"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M670.896 953.38l-138.012-35.31H229.518c-68.144 0-123.586-55.442-123.586-123.586v-67.752l-52.966-56.84L0 679.256v115.226c0 4.472 0.144 8.908 0.396 13.314L351.724 1024h417.534l-98.362-70.62z",
      fill: "#FEA150",
      "p-id": "13725"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M883.31 880.28c-22.488 23.274-53.986 37.788-88.828 37.788H532.884L769.258 1024h25.224c82.404 0 154.792-43.658 195.28-109.054l-54.044-32.188-52.408-2.478z",
      fill: "#FF5D4A",
      "p-id": "13726"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M918.068 652.028v142.456c0 33.304-13.266 63.55-34.758 85.798l106.454 34.666c21.692-35.04 34.236-76.312 34.236-120.466v-125.61l-54.792-30.782-51.14 13.938z",
      fill: "#E45261",
      "p-id": "13727"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1024 298.38l-56.406-13.432-49.526 29.652v337.428L1024 668.872z",
      fill: "#FF4D95",
      "p-id": "13728"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1024 229.518c0-115.266-85.416-210.946-196.272-227.1L688.86 60.202l-70.366 45.73h175.988c68.144 0 123.586 55.442 123.586 123.586V314.6L1024 298.38v-68.862z",
      fill: "#CB319C",
      "p-id": "13729"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M635.464 0L504.1 49.272l-103.61 56.66h218.004L827.728 2.416A230.44 230.44 0 0 0 794.482 0H635.464z",
      fill: "#8A3293",
      "p-id": "13730"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M512 812.138c36.716 0 71.908-6.64 104.452-18.76l-172.04-78.094-182.356-37.314C315.892 758.78 407.826 812.138 512 812.138z",
      fill: "#FF5D4A",
      "p-id": "13731"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M658.306 610.716C626.54 657.646 572.81 688.552 512 688.552c-80.546 0-148.616-54.236-169.734-128.092l-47.364-29.602-81.694 9.076a298.268 298.268 0 0 0 48.85 138.034l354.396 115.41c76.606-28.528 138.474-87.514 170.916-162.136l-63.506-32.17-65.558 11.644z",
      fill: "#E45261",
      "p-id": "13732"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M335.448 512c0-43.756 16.036-83.814 42.494-114.692l-75.316-10.536-76.5 33.784A298.956 298.956 0 0 0 211.862 512c0 9.424 0.488 18.73 1.342 27.932l129.06 20.524A175.948 175.948 0 0 1 335.448 512z m476.69 0c0-64.276-20.318-123.892-54.856-172.78l-74.794-10.616-76.836 33.834c49.746 31.262 82.9 86.596 82.9 149.562 0 36.54-11.16 70.522-30.246 98.716l129.062 20.524A298.324 298.324 0 0 0 812.138 512z",
      fill: "#FF4D95",
      "p-id": "13733"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M512 335.448c34.388 0 66.484 9.918 93.652 26.99l151.63-23.218C702.89 262.234 613.222 211.862 512 211.862c-133.62 0-247.108 87.778-285.874 208.69l151.816-23.248c32.404-37.82 80.464-61.856 134.058-61.856z m282.482-35.31c38.94 0 70.62-31.68 70.62-70.62s-31.68-70.62-70.62-70.62c-38.94 0-70.62 31.68-70.62 70.62s31.68 70.62 70.62 70.62z",
      fill: "#CB319C",
      "p-id": "13734"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M105.932 627.128L54.94 601.694 0 592.632v86.626l105.932 47.474z",
      fill: "#FF5D4A",
      "p-id": "13735"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 506.028v86.604l105.932 34.496V522.874l-55.04-19.788z",
      fill: "#E45261",
      "p-id": "13736"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M105.932 438.958l-54.434-0.492L0 455.18v50.848l105.932 16.846z",
      fill: "#FF4D95",
      "p-id": "13737"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M105.932 359.514l-56.11 5.692L0 411.924v43.256l105.932-16.222z",
      fill: "#CB319C",
      "p-id": "13738"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 411.924l105.932-52.41v-120.79L43.8 244.666 0 286.482z",
      fill: "#8A3293",
      "p-id": "13739"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M410.118 0L168.412 92.962 2.774 193.856A230.44 230.44 0 0 0 0 229.518v56.964l105.932-47.756v-9.21c0-68.144 55.442-123.586 123.586-123.586h170.974L635.464 0H410.118z",
      fill: "#523494",
      "p-id": "13740"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M229.518 0C115.09 0 19.956 84.176 2.774 193.856L410.118 0h-180.6z",
      fill: "#2D2D87",
      "p-id": "13741"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "share-link-text" }, "Instagram")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "share-link-box" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1715327611002",
    class: "icon",
    viewBox: "0 0 1032 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "45437",
    width: "20",
    height: "20"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M869.757322 818.343096h-64.267782v-42.845188h64.267782c21.422594 0 42.845188-17.138075 42.845188-42.845188V188.518828c0-21.422594-17.138075-42.845188-42.845188-42.845188H321.338912c-21.422594 0-42.845188 17.138075-42.845188 42.845188v59.983264h-42.845188V188.518828c0-47.129707 38.560669-85.690377 85.690376-85.690376h548.41841c47.129707 0 85.690377 38.560669 85.690377 85.690376v548.41841c0 42.845188-38.560669 81.405858-85.690377 81.405858z",
      fill: "#0062FF",
      "p-id": "45438"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M205.656904 261.355649H685.523013c72.83682 0 128.535565 55.698745 128.535564 128.535564v415.598327c0 72.83682-55.698745 128.535565-128.535564 128.535565H205.656904c-72.83682 0-128.535565-55.698745-128.535565-128.535565V389.891213c0-68.552301 55.698745-128.535565 128.535565-128.535564z",
      fill: "#0062FF",
      "p-id": "45439"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M579.352636 588.264435c-4.284519 0-8.569038 0-12.853557-4.284519-12.853556-8.569038-12.853556-25.707113-4.284518-34.27615l38.560669-42.845189c21.422594-21.422594 21.422594-59.983264 0-85.690376-21.422594-21.422594-59.983264-21.422594-85.690376 0l-107.112971 119.966527c-8.569038 8.569038-21.422594 8.569038-29.991632 0-8.569038-8.569038-8.569038-21.422594 0-29.991632l111.39749-115.682008c38.560669-38.560669 102.828452-38.560669 145.67364 0 38.560669 38.560669 38.560669 102.828452 0 145.67364l-38.56067 42.845188c-4.284519 0-12.853556 4.284519-17.138075 4.284519zM313.712469 841.051046c-25.707113 0-51.414226-8.569038-72.83682-29.991632-38.560669-42.845188-38.560669-107.112971 0-145.67364l34.27615-34.276151c8.569038-8.569038 21.422594-8.569038 29.991632 0s8.569038 21.422594 0 29.991632c-12.853556 8.569038-34.276151 29.991632-34.276151 29.991632-21.422594 25.707113-21.422594 59.983264 0 85.690377 21.422594 21.422594 59.983264 21.422594 81.405858 0l111.39749-98.543933c8.569038-8.569038 21.422594-8.569038 29.991631 0s8.569038 21.422594 0 29.991631l-107.11297 98.543933c-21.422594 21.422594-47.129707 34.276151-72.83682 34.276151z",
      fill: "#FFFFFF",
      "p-id": "45440"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M399.402845 656.816736c-4.284519 0-12.853556 0-17.138075-4.284518-17.138075-17.138075-29.991632-42.845188-29.991632-64.267783 0-29.991632 8.569038-55.698745 29.991632-77.121339 8.569038-8.569038 21.422594-8.569038 29.991632 0 8.569038 8.569038 8.569038 21.422594 0 29.991632-12.853556 12.853556-17.138075 25.707113-17.138076 42.845188 0 12.853556 8.569038 29.991632 17.138076 38.56067 8.569038 8.569038 8.569038 21.422594 0 29.991632-4.284519 4.284519-8.569038 4.284519-12.853557 4.284518zM476.524184 716.8c-4.284519 0-12.853556 0-12.853556-4.284519-8.569038-8.569038-8.569038-21.422594 0-29.991632 21.422594-21.422594 21.422594-59.983264 0-81.405857-8.569038-8.569038-8.569038-21.422594 0-29.991632 4.284519-8.569038 17.138075-8.569038 25.707113-4.284519 38.560669 38.560669 38.560669 102.828452 0 141.389121 0 8.569038-8.569038 8.569038-12.853557 8.569038z",
      fill: "#FFFFFF",
      "p-id": "45441"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "share-link-text" }, "Copy Link")
], -1))
const _hoisted_21 = { class: "top-btn" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  viewBox: "0 0 33 33",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20.4624 2.69168C24.2935 3.07621 27.3674 5.381 28.0232 9.33478H25.8057L29.3844 14.6592L32.9654 9.33478H30.4955C29.8397 4.01039 25.808 0.54966 20.7148 0.0566174C20.0095 1.14246e-07 19.356 0.603918 19.356 1.37297C19.4032 2.0335 19.8562 2.63506 20.4624 2.69168ZM14.9187 0H2.46993C1.76457 0 1.21019 0.603918 1.21019 1.37297V13.2319C1.21019 14.001 1.76457 14.6049 2.46993 14.6049H14.9187C15.624 14.6049 16.1784 14.001 16.1784 13.2319V1.37297C16.1784 0.603918 15.624 0 14.9187 0ZM13.7085 11.9698H3.68012V2.63506H13.7108V11.9698H13.7085ZM12.4983 30.1982C8.21423 29.8137 4.9375 26.9593 4.78652 22.2364H7.15501L3.57868 16.9121L0 22.2364H2.36849C2.46757 28.3322 6.75161 32.2837 12.2482 32.8333C12.9536 32.8876 13.6094 32.2837 13.6094 31.5146C13.6137 31.1982 13.5037 30.8908 13.2996 30.649C13.0955 30.4071 12.8109 30.2471 12.4983 30.1982ZM30.545 18.2827H18.0939C17.3862 18.2827 16.8342 18.8889 16.8342 19.6556V31.5712C16.8342 32.3379 17.3862 32.9418 18.0939 32.9418H30.5427C31.248 32.9418 31.8 32.3379 31.8 31.5712V19.6556C31.8024 18.8889 31.1985 18.2827 30.545 18.2827ZM29.3325 30.2525H19.3041V20.972H29.3325V30.2525Z",
    fill: "#666666"
  })
], -1))
const _hoisted_23 = {
  class: "tool-box",
  style: {"margin-right":"5px","display":"flex","align-items":"center"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1735301148407",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "9402",
  width: "200",
  height: "200"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M473.344 105.472a32 32 0 0 1 9.28 22.528v177.6C750.272 329.44 960 552.32 960 823.68c0 9.632-0.576 20.864-1.728 33.728l-0.96 9.92a32 32 0 0 1-55.552 18.176 581.536 581.536 0 0 0-43.776-44.224 636.896 636.896 0 0 0-375.36-157.728v173.696a32 32 0 0 1-54.56 22.72L82.976 538.144a64 64 0 0 1-4.16-86.464l4.16-4.48L428.064 105.28a32 32 0 0 1 45.28 0.192zM128.064 492.64l290.528 287.84v-165.824l68.736 5.056a700.832 700.832 0 0 1 407.264 168.544c-17.184-220.352-193.12-398.848-417.664-418.88l-58.336-5.248V204.8L128 492.672z",
    fill: "currentColor",
    "p-id": "9403"
  })
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1735301091327",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "5932",
  width: "200",
  height: "200"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M98.592 896a30.72 30.72 0 0 0 27.2-16c83.68-147.712 236.224-238.88 401.568-240v224a32 32 0 0 0 19.136 29.44 30.08 30.08 0 0 0 33.696-6.72l370.656-384.032c5.856-6.016 9.152-14.176 9.152-22.72 0-8.544-3.296-16.704-9.152-22.72l-370.656-384a30.08 30.08 0 0 0-33.696-6.72 32 32 0 0 0-19.136 29.44v163.52C263.008 294.656 64.768 527.36 64 803.488c0.064 21.44 1.408 42.784 4 64 1.6 13.664 11.424 24.768 24.416 27.52l6.176 0.992z m459.648-320h-15.424c-159.456-2.4-311.904 67.776-417.024 192 19.2-239.808 203.648-429.696 435.232-448.032 15.968-1.504 28.16-15.392 28.128-32v-114.88l296.224 306.88-296.224 306.88V608c0-17.664-13.856-32-30.912-32z",
    fill: "currentColor",
    "p-id": "5933"
  })
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1735300638718",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "1495",
  width: "200",
  height: "200"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M924.5 337.9c-22.6-53.3-54.8-101.2-95.9-142.3-41.1-41.1-89-73.4-142.3-95.9C631.1 76.4 572.4 64.5 512 64.5c-60.4 0-119.1 11.8-174.3 35.2-53.3 22.6-101.2 54.8-142.3 95.9s-73.4 89-95.9 142.3c-23.4 55.2-35.2 113.9-35.2 174.3s11.8 119.1 35.2 174.3c22.6 53.3 54.8 101.2 95.9 142.3s89 73.4 142.3 95.9c55.2 23.4 113.9 35.2 174.3 35.2 60.4 0 119.1-11.8 174.3-35.2 53.3-22.6 101.2-54.8 142.3-95.9 41.1-41.1 73.4-89 95.9-142.3 23.4-55.2 35.2-113.9 35.2-174.3s-11.8-119-35.2-174.3z m-146.8 440c-71 71-165.3 110-265.7 110-100.4 0-194.7-39.1-265.7-110-71-71-110-165.3-110-265.7s39.1-194.7 110-265.7 165.3-110 265.7-110c100.4 0 194.7 39.1 265.7 110s110 165.3 110 265.7-39.1 194.7-110 265.7z",
    "p-id": "1496"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M706.7 464.8L447.6 300.6c-17.3-11-39.2-11.6-57.1-1.8-17.9 9.9-29.1 28.7-29.1 49.2v328c0 20.5 11.1 39.3 29.1 49.2 8.5 4.7 17.8 7 27.1 7 10.4 0 20.9-2.9 30-8.7l259.1-163.8c16.4-10.3 26.1-28.1 26.2-47.5-0.1-19.3-9.9-37.1-26.2-47.4zM433.4 647.3V376.8L647 512.2 433.4 647.3z",
    "p-id": "1497"
  })
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1735301204088",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "10389",
  width: "200",
  height: "200",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M629.557 391.972c17.329 17.32 47.028 17.32 66.815 0l168.302-165.814v133.637c0 19.806 14.85 34.647 34.637 34.647h24.743c19.806 0 34.657-12.372 34.657-29.692V119.733h-2.479l2.479-17.318c0-9.904-2.479-17.33-7.436-24.752-4.936-4.948-14.848-9.895-24.743-9.895h-17.327L664.211 65.29c-19.805 0-34.654 17.329-34.654 34.646v24.752c2.478 22.274 19.789 34.646 39.593 34.646h128.69L632.036 325.149c-22.283 17.319-22.283 47.026-2.478 66.823zM394.44 629.557c-17.31-17.327-47.009-17.327-66.815 0l-168.3 165.807V664.195c0-19.787-14.833-34.638-34.638-34.638h-24.76c-19.788 0-34.639 12.372-34.639 29.699v242.533h2.478l-2.478 17.327c0 9.894 2.478 17.31 7.416 24.744 4.956 4.956 14.868 9.894 24.761 9.894h17.328l244.993 2.478c19.823 0 34.655-17.328 34.655-34.638v-24.76c-2.478-22.266-19.788-34.638-39.593-34.638H226.16l168.283-165.824c17.327-17.327 17.327-47.027-0.001-66.815z m561.79 274.709v-242.55c0-19.787-17.329-29.68-34.639-29.68h-24.759c-19.788 0-34.639 17.31-34.639 34.638v131.168l-168.3-165.806c-17.309-17.329-47.01-17.329-66.816 0-17.326 17.31-17.326 47.009 0 66.814l168.284 165.806h-128.69c-19.787 0-37.116 12.388-39.594 34.654v24.745c0 19.805 17.33 34.654 34.64 34.654l240.071-2.478h17.329c9.893 0 17.31-2.478 24.743-9.894 4.955-4.956 7.415-14.85 7.415-24.744l4.955-17.327c-2.478 0 0 0 0 0zM228.636 159.335h128.69c19.806 0 37.116-12.373 39.593-34.646V99.936c0-19.797-17.309-34.646-34.654-34.646l-244.993 2.478H99.927c-9.876 0-17.31 2.478-24.743 9.895-4.939 4.956-7.416 14.849-7.416 24.752l2.477 17.318h-2.477v245.018c0 19.797 14.85 29.692 34.638 29.692h24.743c19.823 0 34.655-14.841 34.655-34.646v-133.64l168.283 165.815c17.345 17.32 47.045 17.32 66.832 0 17.33-17.327 17.33-47.026 0-66.823L228.636 159.335z m0 0",
    "p-id": "10390"
  })
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1735301249788",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "11379",
  width: "200",
  height: "200"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M512 0C229.696 0 0 229.696 0 512s229.696 512 512 512 512-229.696 512-512-229.696-512-512-512z m0 931.2A419.712 419.712 0 0 1 92.8 512 419.712 419.712 0 0 1 512 92.8 419.712 419.712 0 0 1 931.2 512 419.712 419.712 0 0 1 512 931.2z",
    fill: "currentColor",
    "p-id": "11380"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M507.328 192.256c-75.904 3.52-134.528 41.856-165.184 108.032A246.848 246.848 0 0 0 320 396.288l89.664 0.128c0-0.32 0.512-31.168 14.912-60.736 16.96-34.944 44.544-52.096 86.848-54.016 41.792-1.92 71.68 10.24 88.64 36.096 16.896 25.792 15.36 55.68 11.968 62.528-13.696 23.488-40.96 51.52-60.8 72.064-9.728 9.984-18.112 18.56-24.448 26.048a410.688 410.688 0 0 1-4.608 5.248c-20.096 22.976-57.6 65.728-57.6 156.352h89.6c0-56.96 18.88-78.464 35.456-97.344l5.568-6.4c4.416-5.184 12.16-13.184 20.416-21.696 23.04-23.808 54.656-56.32 73.856-89.216 23.04-39.232 18.304-102.912-11.2-151.488-19.712-32.448-68.032-86.272-170.944-81.6zM448 768a64 64 0 1 0 128 0 64 64 0 0 0-128 0z",
    fill: "currentColor",
    "p-id": "11381"
  })
], -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "top-btn" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  viewBox: "0 0 35 35",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M28.3606 9.22583L27.2699 10.3165L27.7039 9.88252C28.0511 9.49379 28.036 8.89748 27.6624 8.52385L28.3606 9.22583ZM22.4391 3.29297L23.5298 4.38368L23.0958 3.94966C22.707 3.60244 22.1107 3.61754 21.7371 3.99117L22.4391 3.29297ZM34.1312 33.0818C34.1312 32.2289 33.4405 31.5344 32.5838 31.5344H1.66651C0.813572 31.5344 0.119141 32.2251 0.119141 33.0818C0.119141 33.9348 0.809798 34.6292 1.66651 34.6292H32.5876C33.4405 34.6254 34.1312 33.9348 34.1312 33.0818ZM4.10835 29.119C4.96129 29.119 5.65572 28.4284 5.65572 27.5716V19.4611C5.65572 18.6082 4.96506 17.9138 4.10835 17.9138C3.2554 17.9138 2.56097 18.6044 2.56097 19.4611V27.5716C2.56097 28.4284 3.2554 29.119 4.10835 29.119Z",
    fill: "#666666"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.56104 27.5752C2.56104 28.4281 3.25169 29.1226 4.10841 29.1226H12.1963C13.0492 29.1226 13.7436 28.4319 13.7436 27.5752C13.7436 26.7223 13.053 26.0278 12.1963 26.0278H4.10841C3.25547 26.0278 2.56104 26.7223 2.56104 27.5752Z",
    fill: "#666666"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M30.9081 7.41412C30.9044 7.41034 30.8968 7.40657 30.893 7.39902L24.1223 0.628313C23.1147 -0.247274 21.5824 -0.209533 20.6238 0.752858C20.62 0.756632 20.6162 0.76418 20.6087 0.767954L2.99879 18.3741C2.39494 18.9779 2.39494 19.9554 2.99879 20.5592C3.60264 21.1631 4.58013 21.1631 5.18398 20.5592L22.4315 3.31169L28.3455 9.2219L11.1017 26.4657C10.4979 27.0695 10.4979 28.047 11.1017 28.6509C11.7056 29.2547 12.6831 29.2547 13.2869 28.6509L31.078 10.8599C31.9045 9.85217 31.8479 8.35764 30.9081 7.41412Z",
    fill: "#666666"
  })
], -1))
const _hoisted_36 = { class: "new_handler_item" }
const _hoisted_37 = { class: "viewport-size-preset" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "text" }
const _hoisted_40 = { class: "btn-list" }
const _hoisted_41 = { style: {"text-align":"center"} }
const _hoisted_42 = { class: "propInfo" }

import useClipboard from 'vue-clipboard3';
import { onMounted, ref, h } from 'vue';
import { storeToRefs } from 'pinia';
import { useMainStore, useSnapshotStore } from '@/store';
import { getImageDataURL } from '@/utils/image';
import { ShapePoolItem } from '@/configs/shapes';
import { LinePoolItem } from '@/configs/lines';
import useScaleCanvas from '@/hooks/useScaleCanvas';
import useHistorySnapshot from '@/hooks/useHistorySnapshot';
import useCreateElement from '@/hooks/useCreateElement';
import useScreening from '@/hooks/useScreening';
import useSlideHandler from '@/hooks/useSlideHandler';
import { event } from 'vue-gtag';
import Cookies from 'js-cookie';
import uniWebview from '@dcloudio/uni-webview-js';
import ShapePool from './ShapePool.vue';
import LinePool from './LinePool.vue';
import ChartPool from './ChartPool.vue';
import TableGenerator from './TableGenerator.vue';
import MediaInput from './MediaInput.vue';
import LaTeXEditor from '@/components/LaTeXEditor/index.vue';
import FileInput from '@/components/FileInput.vue';
import HotkeyDoc from '@/views/Editor/EditorHeader/HotkeyDoc.vue';
import {
  CaretRightOutlined,
  RetweetOutlined,
  LayoutOutlined,
  SmileOutlined,
} from '@ant-design/icons-vue';
import {
  Tooltip,
  Popover,
  Modal,
  Button,
  Dropdown,
  Drawer,
  Menu,
  Avatar,
  notification,
  message,
} from 'ant-design-vue';
import {
  saveClickData,
  getUserCanChat,
  getPromotionCode,
  getUserCanChatAndDownLoad,
} from '@/api/combo';
import { useI18n } from 'vue-i18n';
import { sendClickData } from '@/utils/common';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  isEnd: {
    type: Boolean,
    default: false,
  },
  isStop: {
    type: Boolean,
    default: false,
  },
  waitTime: {
    type: Number,
  },
  canDownLoad: {
    type: Boolean,
    default: false,
  },
  isVip: {
    type: Boolean,
    default: false,
  },
  paid: {
    type: Number,
    default: 0,
  },
  recordId: {
    type: Number || String,
    default: '',
  },
  isPaid: {
    type: Boolean,
    default: false,
  },
  isPc: {
    type: Boolean,
    default: false,
  },
  isPaidTemplate: {
    type: Boolean,
    default: false,
  },
  isPaidTemplateId: {
    type: Number,
    default: 0,
  },
},
  emits: ["save", "continueContent", "changeTemplateHandle", "setShareAuth"],
  setup(__props, { emit }: { emit: ({
  (event: 'save'): void;
  (event: 'continueContent'): void;
  (event: 'changeTemplateHandle'): void;
  (event: 'setShareAuth', data: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const { t, locale } = useI18n();
const noPricing = ref(false);
const promotionCode = ref('');





const handleContinueContent = () => {
  emit('continueContent');
};
const handleChangeTemplateHandle = () => {
  emit('changeTemplateHandle');
};

const handleGetCode = () => {
  getPromotionCode()
    .then((res: any) => {
      promotionCode.value = res.data;
    })
    .catch((err: any) => { });
};

const mainStore = useMainStore();
const { creatingElement, gridLineSize, showRuler, showSelectPanel, isPc, pptId } =
  storeToRefs(mainStore);
const { canUndo, canRedo } = storeToRefs(useSnapshotStore());

const MenuItem = Menu.Item;
const setDialogForExport = mainStore.setDialogForExport;
const { enterScreening } = useScreening();
const { createSlide, deleteSlide, resetSlides } = useSlideHandler();
const toggleGridLines = () => {
  mainStore.setGridLineSize(gridLineSize.value ? 0 : 50);
};
const toggleRuler = () => {
  mainStore.setRulerState(!showRuler.value);
};
const openSelectPanel = () => {
  if (!showSelectPanel.value) mainStore.setSelectPanelState(true);
  else mainStore.setSelectPanelState(false);
};

const { redo, undo } = useHistorySnapshot();

const {
  scaleCanvas,
  setCanvasScalePercentage,
  resetCanvas,
  canvasScalePercentage,
} = useScaleCanvas();

const canvasScalePresetList = [200, 150, 100, 80, 50];
const canvasScaleVisible = ref(false);
const hotkeyDrawerVisible = ref(false);

const applyCanvasPresetScale = (value: number) => {
  setCanvasScalePercentage(value);
  canvasScaleVisible.value = false;
};

const { toClipboard } = useClipboard();

const skipLink = async (data: string) => {
  const userAgent = navigator.userAgent.split('///');
  if (userAgent.length > 0) {
    const fromApp = userAgent[0].indexOf('uni-app');
    if (fromApp !== -1) {
      uniWebview.postMessage({
        data: { fromApp: true },
      });
    }
  }
  if (!props.isVip)
    return (window.parent.location.href = '/pricing?from=share');
  emit('setShareAuth', data);
};
const {
  createImageElement,
  createChartElement,
  createTableElement,
  createLatexElement,
  createVideoElement,
  createAudioElement,
} = useCreateElement();

const insertImageElement = (files: FileList) => {
  const imageFile = files[0];
  if (!imageFile) return;
  getImageDataURL(imageFile).then(dataURL => createImageElement(dataURL));
};

const shapePoolVisible = ref(false);
const linePoolVisible = ref(false);
const chartPoolVisible = ref(false);
const tableGeneratorVisible = ref(false);
const mediaInputVisible = ref(false);
const latexEditorVisible = ref(false);
const savePptVisible = ref(false);
const textTypeSelectVisible = ref(false);

// 去pc端编辑提示
const goPcTips = () => {
  notification.open({
    message: t(`public.systemMsg`),
    description: t(`mobile.index.editTips`),
    // icon: () => h(SmileOutlined, { style: 'color: #108ee9' }),
    style: {
      borderRadius: '10px',
    },
  });
};

// 去pc端下载提示
const goPcUploadPdf = () => {
  notification.open({
    message: t(`public.systemMsg`),
    description: t(`editor.exportDialog.tips`),
    // icon: () => h(SmileOutlined, { style: 'color: #108ee9' }),
    style: {
      borderRadius: '10px',
    },
  });
};

// 绘制文字范围
const drawText = (vertical = false) => {
  mainStore.setCreatingElement({
    type: 'text',
    vertical,
  });
};

// 绘制形状范围
const drawShape = (shape: ShapePoolItem) => {
  mainStore.setCreatingElement({
    type: 'shape',
    data: shape,
  });
  shapePoolVisible.value = false;
};

// 绘制线条路径
const drawLine = (line: LinePoolItem) => {
  mainStore.setCreatingElement({
    type: 'line',
    data: line,
  });
  linePoolVisible.value = false;
};

const onSave = () => {
  emit('save');
  savePptVisible.value = false;
};

const close = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.parent.onClose();
};
let userInfoStr = localStorage.getItem('user');
let userInfo = userInfoStr ? JSON.parse(userInfoStr) : null;

const exportValid = (type: any) => {
  const userAgent = navigator.userAgent.split('///');
  if (userAgent.length > 0) {
    const fromApp = userAgent[0].indexOf('uni-app');
    if (fromApp !== -1) {
      goPcUploadPdf();
      return new Promise<void>(resolve => resolve());
    }
  }
  let userList = Cookies.get('e_a_u');
  let uid = Cookies.get('uid');
  if (userList != undefined) {
    if (uid && userList.split(',').indexOf(uid) == -1) {
      // event('ppt_download');
    }
  } else {
    // event('ppt_download');
  }

  if (props.isVip || props.paid == 2 || props.paid == 3 || props.canDownLoad) {
    setDialogForExport(type);
  } else if (props.recordId) {
    getUserCanChatAndDownLoad(props.recordId).then((res: any) => {
      if (res.data.dl || res.data.invitation) {
        setDialogForExport(type);
      } else {
        window.parent.location.href = '/pricing?d=3';
      }
    });
    // noPricing.value = true;
  } else {
    window.parent.location.href = '/pricing?d=3';
  }
};

const handleEnterScreening = () => {
  // enterScreening()
  getUserCanChatAndDownLoad(pptId.value)
    .then((res: any) => {
      if (res.data.isVip || res.data.chat) {
        enterScreening();
      } else {
        window.parent.location.href = '/pricing?d=3';
        // noPricing.value = true;
      }
    })
    .catch((err: any) => { });
};

const handleGetTokens = async () => {
  let userList = Cookies.get('e_a_u');
  let uid = Cookies.get('uid');
  if (userList != undefined) {
    if (uid && userList.split(',').indexOf(uid) == -1) {
      // event('12');
    }
  } else {
    // event('12');
  }
  noPricing.value = false;
  // ppt Upgrade to Pro=21
  let currentUrl = window.location.href || '';
  await sendClickData(24, currentUrl, '', 'canvastool');
  window.parent.location.href = '/pricing?d=3';
};

const handleReturn = () => {
  window.parent.location.href = '/aiPowerPoint';
};

return (_ctx: any,_cache: any) => {
  const _component_IconMinus = _resolveComponent("IconMinus")!
  const _component_IconPlus = _resolveComponent("IconPlus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(userInfo))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "back-workspase",
            onClick: handleReturn
          }, [
            (_unref(userInfo).avatar)
              ? (_openBlock(), _createBlock(_unref(Avatar), {
                  key: 0,
                  src: _unref(userInfo).avatar
                }, null, 8, ["src"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(userInfo).nickName), 1)),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(`editor.canvasTool.index.workspase`)), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(Tooltip), {
        color: "#5230f2",
        mouseLeaveDelay: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (exportValid('pptx'))),
        title: _unref(t)(`editor.canvasTool.index.download`)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`editor.canvasTool.index.download`)), 1)
          ])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_unref(Tooltip), {
        color: "#5230f2",
        mouseLeaveDelay: 0,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (savePptVisible.value = true)),
        title: _unref(t)(`editor.canvasTool.index.save`)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`editor.canvasTool.index.save`)), 1)
          ])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_unref(Dropdown), { trigger: ['click'] }, {
        overlay: _withCtx(() => [
          _createVNode(_unref(Menu), null, {
            default: _withCtx(() => [
              _createVNode(_unref(MenuItem), {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (skipLink('LinkedIn')))
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (skipLink('Facebook')))
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (skipLink('Tiktok')))
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (skipLink('Twitter')))
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (skipLink('Instagram')))
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (skipLink('copy')))
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`editor.canvasTool.index.share`)), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(Tooltip), {
        color: "#5230f2",
        mouseLeaveDelay: 0,
        title: _unref(t)(`editor.canvasTool.index.templateReplacement`),
        onClick: handleChangeTemplateHandle
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`editor.canvasTool.index.templateReplacement`)), 1)
          ])
        ]),
        _: 1
      }, 8, ["title"]),
      _withDirectives(_createElementVNode("div", _hoisted_23, [
        _createVNode(_unref(Tooltip), {
          color: "#5230f2",
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`editor.canvasTool.index.ctrlZ`)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "tool-box-item",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(undo)())),
              style: _normalizeStyle({ color: _unref(canUndo) ? '#333333' : '#999999' })
            }, _hoisted_25, 4)
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          color: "#5230f2",
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`editor.canvasTool.index.reSet`)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "tool-box-item",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(redo)())),
              style: _normalizeStyle({ color: _unref(canRedo) ? '#333333' : '#999999' })
            }, _hoisted_27, 4)
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          color: "#5230f2",
          mouseLeaveDelay: 0,
          title: _unref(t)(`editor.editorHeader.index.pptShow`)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (handleEnterScreening())),
              class: "tool-box-item"
            }, _hoisted_29)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_unref(Tooltip), {
          color: "#5230f2",
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`editor.canvasTool.index.screen`)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "tool-box-item",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(resetCanvas)()))
            }, _hoisted_31)
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          color: "#5230f2",
          mouseLeaveDelay: 0,
          title: _unref(t)(`editor.editorHeader.index.help`)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "tool-box-item",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (hotkeyDrawerVisible.value = true))
            }, _hoisted_33)
          ]),
          _: 1
        }, 8, ["title"])
      ], 512), [
        [_vShow, _unref(isPc)]
      ]),
      _createVNode(_unref(Tooltip), {
        color: "#5230f2",
        mouseLeaveDelay: 0,
        title: _unref(t)(`public.edit`)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dropdown), { trigger: ['click'] }, {
            overlay: _withCtx(() => [
              _createVNode(_unref(Menu), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(MenuItem), {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(undo)()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`editor.editorHeader.index.undo`)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MenuItem), {
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(redo)()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`editor.editorHeader.index.redo`)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MenuItem), {
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(createSlide)()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`editor.editorHeader.index.createSlide`)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MenuItem), {
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_unref(deleteSlide)()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`editor.editorHeader.index.deleteSlide`)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MenuItem), {
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (toggleGridLines()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(gridLineSize)
                  ? _ctx.$t(`editor.editorHeader.index.closeGridLines`)
                  : _ctx.$t(`editor.editorHeader.index.openGridLines`)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MenuItem), {
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (toggleRuler()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(showRuler)
                  ? _ctx.$t(`editor.editorHeader.index.closeRuler`)
                  : _ctx.$t(`editor.editorHeader.index.openRuler`)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MenuItem), {
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_unref(resetSlides)()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`editor.editorHeader.index.resetSlides`)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`public.edit`)), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"]),
      _withDirectives(_createElementVNode("div", _hoisted_36, [
        _createVNode(_component_IconMinus, {
          class: "handler-item viewport-size",
          onClick: _cache[20] || (_cache[20] = ($event: any) => (_unref(scaleCanvas)('-')))
        }),
        _createVNode(_unref(Popover), {
          trigger: "click",
          visible: canvasScaleVisible.value,
          "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((canvasScaleVisible).value = $event))
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_37, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(canvasScalePresetList, (item) => {
                return _createElementVNode("div", {
                  class: "preset-item",
                  key: item,
                  onClick: ($event: any) => (applyCanvasPresetScale(item))
                }, _toDisplayString(item) + "% ", 9, _hoisted_38)
              }), 64))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(canvasScalePercentage)), 1)
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_IconPlus, {
          class: "handler-item viewport-size",
          onClick: _cache[22] || (_cache[22] = ($event: any) => (_unref(scaleCanvas)('+')))
        })
      ], 512), [
        [_vShow, _unref(isPc)]
      ])
    ]),
    _createVNode(_unref(Modal), {
      visible: latexEditorVisible.value,
      "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((latexEditorVisible).value = $event)),
      footer: null,
      centered: "",
      width: 880,
      destroyOnClose: ""
    }, {
      default: _withCtx(() => [
        _createVNode(LaTeXEditor, {
          onClose: _cache[23] || (_cache[23] = ($event: any) => (latexEditorVisible.value = false)),
          onUpdate: _cache[24] || (_cache[24] = data => {
        _unref(createLatexElement)(data);
        latexEditorVisible.value = false;
      }
        )
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Modal), {
      style: {"width":"300px"},
      visible: savePptVisible.value,
      "onUpdate:visible": _cache[27] || (_cache[27] = ($event: any) => ((savePptVisible).value = $event)),
      centered: "",
      closable: false,
      destroyOnClose: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", {
            class: "btn",
            onClick: _cache[26] || (_cache[26] = ($event: any) => (savePptVisible.value = false))
          }, _toDisplayString(_unref(t)(`index.cBtn`)), 1),
          _createElementVNode("div", {
            class: "btn primary",
            onClick: onSave
          }, _toDisplayString(_unref(t)(`index.sBtn`)), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_41, _toDisplayString(_unref(t)(`index.saveMessage`)), 1)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Drawer), {
      width: "320",
      placement: "right",
      closable: false,
      visible: hotkeyDrawerVisible.value,
      onClose: _cache[28] || (_cache[28] = ($event: any) => (hotkeyDrawerVisible.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(HotkeyDoc)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Modal), {
      visible: noPricing.value,
      "onUpdate:visible": _cache[29] || (_cache[29] = ($event: any) => ((noPricing).value = $event)),
      title: _unref(t)(`public.systemMsg`),
      onOk: handleGetTokens,
      "ok-text": _unref(t)(`editor.editorHeader.index.getTokens`),
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_unref(t)(`editor.editorHeader.index.Feedback`)), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title", "ok-text"])
  ]))
}
}

})